define(
    'connections/draft-connection',[
        'jquery',

        'utils/ajax-util',

        'settings',
    ],

    function ($, ajax, settings) {
        /**
         * @class Cart
         */
        return (function () {

            /**
             * @constructor
             */
            function DraftConnection () {}

            /**
             * Load a list of drafts 
             *
             * @method add
             * @param data
             * @returns {promise}
             */
            DraftConnection.prototype.load = function() {
                return ajax.get(settings.draftApiUrl);
            };

            DraftConnection.prototype.save = function(name) {
                // TODO:
                // return $.ajax({
                //     type: "POST",
                //     url: settings.draftApiUrl + '/save',
                //     data: { skuQuantityList: data },
                //     error: _this.notifyError
                // });
            };

            DraftConnection.prototype.removeDraft = function(draftId) {
                return ajax.delete(settings.draftDeleteApiUrl.replace(':id', draftId));
            };

            return new DraftConnection();
        })();
    }
);

